import { GetSortIndex, compare } from "./common";

/**
 * Alphabetical sorting restricted to Norwegian locale, for consistent sorting on server and client
 * (radash's `alphabetical()` is inconsistent between these two)
 */
export const sortAlphabetical = <T>(array: T[], indexFunction?: GetSortIndex<T>): T[] =>
  array.slice().sort((left, right) => compare(left, right, indexFunction));
